<ng-container [ngSwitch]="index">
	<div *ngSwitchCase="0">
		<form [formGroup]="empresaSelect" (ngSubmit)="onEmpresaSelectSubmit()">
			<div class="flex flex-column gap-2 px-3">
				<main class="grid formgrid p-fluid">
					<div class="field col-12">
            <p-iconField iconPosition="left">
              <p-inputIcon styleClass="pi pi-building z-1"></p-inputIcon>
              <p-dropdown [options]="empresa" formControlName="empresaSelectedId" appendTo="body" class="container-dropdown-input"
                          [placeholder]="translations.empresa" optionLabel="nombre" optionValue="id" autoWidth="false"
                          [style]="{'width':'100%'}">
              </p-dropdown>
            </p-iconField>
						<ng-container
							*ngIf="empresaSelect.get('empresaSelectedId')?.invalid && empresaSelect.get('empresaSelectedId')?.dirty">
							<app-form-group-error-message
								[control]="empresaSelect.get('empresaSelectedId')"/>
						</ng-container>
					</div>
					<div class="col-12 mt-4">
						<div class="flex justify-content-center gap-3">
							<button pButton type="submit" [label]="translations.seleccionar" class="w-10rem border-round-xl"
								></button>
							<button pButton type="button" [label]="translations.registrar"
                      class="border-round-xl w-15rem" (click)="onTabChange(1)"></button>
						</div>
					</div>
				</main>
			</div>
		</form>
	</div>
	<div *ngSwitchCase="1">
		<form [formGroup]="empresaCreate" (ngSubmit)="onEmpresaCreateSubmit()">
			<div class="flex flex-column gap-2 px-3">
				<main class="grid formgrid p-fluid">
          <div class="field col-12 mb-4">
            <p-iconField iconPosition="left">
              <p-inputIcon styleClass="pi pi-shop"></p-inputIcon>
              <input pInputText formControlName="nombre" id="nombre" type="text"
                     [placeholder]="translations.nombre"
                     style="width: 100%" class="container-input"/>
            </p-iconField>
            <ng-container *ngIf="empresaCreate.get('nombre')?.invalid && empresaCreate.get('nombre')?.touched">
              <app-form-group-error-message [control]="empresaCreate.get('nombre')"/>
            </ng-container>
          </div>
					<div class="field col-12 mb-4">
            <p-iconField iconPosition="left">
              <p-inputIcon styleClass="pi pi-hashtag"></p-inputIcon>
              <input pInputText formControlName="nit" id="nit" type="text"
                      class="container-input"
                     [placeholder]="translations.nit" style="width: 100%"/>
            </p-iconField>
						<ng-container *ngIf="empresaCreate.get('nit')?.invalid && empresaCreate.get('nit')?.touched">
							<app-form-group-error-message [control]="empresaCreate.get('nit')"/>
						</ng-container>
					</div>
					<div class="field col-12 mb-4">
            <p-iconField iconPosition="left">
              <p-inputIcon styleClass="pi pi-address-book"></p-inputIcon>
              <input pInputText formControlName="direccion" id="direccion"
                     class="container-input"
                     [placeholder]="translations.direccion" type="text" style="width: 100%"/>
            </p-iconField>
						<ng-container *ngIf="empresaCreate.get('direccion')?.invalid && empresaCreate.get('direccion')?.touched">
							<app-form-group-error-message [control]="empresaCreate.get('direccion')"/>
						</ng-container>
					</div>
					<div class="field col-12 mb-4">
            <p-iconField iconPosition="left">
              <p-inputIcon styleClass="pi pi-phone"></p-inputIcon>
              <input pInputText formControlName="telefono"
                     [placeholder]="translations.telefono" id="telefono"
                     type="text" class="container-input" style="width: 100%"/>
            </p-iconField>
						<ng-container *ngIf="empresaCreate.get('telefono')?.invalid && empresaCreate.get('telefono')?.touched">
							<app-form-group-error-message [control]="empresaCreate.get('telefono')"/>
						</ng-container>
					</div>
					<div class="field col-12 mb-4">
            <p-iconField iconPosition="left">
              <p-inputIcon styleClass="pi pi-envelope"></p-inputIcon>
              <input pInputText formControlName="correo" id="correo"
                     [placeholder]="translations.correo"
                     class="container-input" type="text" style="width: 100%"/>
            </p-iconField>
						<ng-container *ngIf="empresaCreate.get('correo')?.invalid && empresaCreate.get('correo')?.touched">
							<app-form-group-error-message [control]="empresaCreate.get('correo')"/>
						</ng-container>
					</div>
					<div class="col-12">
            <div class="flex flex-wrap gap-1">
							<div class="flex flex-column">
								<div class="flex">
									<p-fileUpload #fileUpload mode="basic" accept="application/pdf" [maxFileSize]="uploadFileSize"
										[chooseLabel]="translations.agregarDocumento" [customUpload]="true" [auto]="true" class=""
										(uploadHandler)="uploadHandler($event, fileUpload)" chooseIcon="pi pi-upload"></p-fileUpload>
									<button pButton icon="pi pi-trash" class="p-button-cancel-fileupload cancel border-noround-left" (click)="removeFile()"
										[disabled]="!archivo"></button>
								</div>
								<ng-container *ngIf="invalidSize">
									<small class="p-error block"> <strong>{{archivo?.name}}</strong>: {{translations.invalidSize}} </small>
								</ng-container>
								<ng-container *ngIf="requieredFile">
									<small class="p-error block">{{translations.campoRequerido}}</small>
								</ng-container>
								<div *ngIf="archivo">
									<p>{{translations.archivo}} "{{archivo.name}}" {{translations.wasUploaded}}
									</p>
								</div>
							</div>
						</div>
					</div>
					<div class="col-12 mt-4">
						<div class="flex justify-content-center gap-3">
							<button pButton type="submit" [label]="translations.registrar"
								class="border-round-xl w-15rem" ></button>
							<button pButton type="button" [label]="translations.limpiar"
                      class="border-round-xl p-button-secondary w-10rem" (click)="onLimpiarDatos()"></button>
						</div>
					</div>
				</main>
			</div>
		</form>
	</div>
</ng-container>
